import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AttachmentActivity } from 'sspapp/modules/ticket/ticket.model';

/** Component for an local attachment activity */
@Component({
  selector: 'ssp-local-attachment-activity',
  templateUrl: './local-attachment-activity.component.html',
  styleUrls: ['./local-attachment-activity.component.scss'],
})
export class LocalAttachmentActivityComponent {
  /** The local file to be uploaded */
  @Input()
  public file: File;

  /** Note activity for the local attachment */
  @Input()
  public parentActivity: AttachmentActivity;

  @Output()
  /** Callback invoke to delete the attachment */
  public onDelete = new EventEmitter<AttachmentActivity>();

  @Output()
  /** Callback to invoke when an error occurs  */
  public onError = new EventEmitter<void>();

  @ViewChild('popupDelete', { static: false }) popupDelete;  

  public attachmentDescription: string = "";

  constructor() { }

  public delete = () => {
    this.onDelete.emit(this.parentActivity);
  }

  public cancelDelete() {
    this.popupDelete.close();
  };

}
